export const enum ScrollMode {
    MouseWheel = 'mousewheel',
    ClickAndDrag = 'clickanddrag',
}
